import { Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "label-with-description-popover",
  templateUrl: "./label-with-description-popover.component.html",
  styleUrls: ["./label-with-description-popover.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class LabelWithDescriptionPopoverComponent {
  @Input() public readonly = false;

  @Input() public label: string;
  @Input() public description: string;
  @Input() public descriptionKey: string;


  @Input() public position: string = "bottom";
  @Input() public trigger: string = "click";
}
